<template>
  <span class="credit-money-text"><span v-for="(segment, index) in segments" :key="index" :class="segment.className">{{ segment.text }}</span></span>
</template>

<script>
import { creditMoneySegments, creditShortMoneySegments } from '../../../credit-money-text';

export default {
  name: 'CreditMoneyText',
  props: {
    text: { type: [String, Number], default: '' },
    locale: { type: String, default: '' },
    abbreviated: { type: Boolean, default: false }
  },
  computed: {
    segments() {
      const locale = this.locale || (typeof document !== 'undefined' && document.documentElement.lang) || 'es';
      return this.abbreviated ? creditShortMoneySegments(this.text, locale) : creditMoneySegments(this.text, locale);
    }
  }
};
</script>
